/**
 * Flip to `false` when the app should be live again (when env is unset).
 * Build with `REACT_APP_MAINTENANCE_MODE=false` to force the full app on without editing code.
 */
const DEFAULT_MAINTENANCE = true;

const fromEnv = process.env.REACT_APP_MAINTENANCE_MODE;
const envOff = fromEnv === "false";
const envOn = fromEnv === "true";

export const MAINTENANCE_MODE = envOff
  ? false
  : envOn
    ? true
    : DEFAULT_MAINTENANCE;
